export type MoneyCents = number & { readonly __brand: 'MoneyCents' };

function roundHalfAwayFromZero(value: number): number {
  const absolute = Math.abs(value);
  const correction = Number.EPSILON * Math.max(1, absolute);
  return Math.sign(value) * Math.round(absolute + correction);
}

export function moneyToCents(value: number): MoneyCents {
  if (!Number.isFinite(value)) return 0 as MoneyCents;
  return roundHalfAwayFromZero(value * 100) as MoneyCents;
}

export function centsToMoney(value: number): number {
  if (!Number.isFinite(value)) return 0;
  return roundHalfAwayFromZero(value) / 100;
}

export function roundMoney(value: number): number {
  return centsToMoney(moneyToCents(value));
}

export function multiplyMoney(quantity: number, unitPrice: number): number {
  if (
    !Number.isFinite(quantity) ||
    !Number.isFinite(unitPrice) ||
    quantity < 0 ||
    unitPrice < 0
  ) {
    return 0;
  }

  const unitPriceCents = moneyToCents(unitPrice);
  return centsToMoney(roundHalfAwayFromZero(quantity * unitPriceCents));
}

export function sumMoney(values: Iterable<number>): number {
  let totalCents = 0;
  for (const value of values) {
    totalCents += moneyToCents(value);
  }
  return centsToMoney(totalCents);
}

export function calculatePercentageMoney(value: number, rate: number): number {
  if (!Number.isFinite(value) || !Number.isFinite(rate)) return 0;
  return centsToMoney(roundHalfAwayFromZero(moneyToCents(value) * rate));
}
